import { EmailEditorPageMode } from 'broker/enums';
import EmailEditorInnerPageContentWrapper from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/EmailEditorInnerPage/EmailEditorInnerPageContentWrapper';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

export default function Solicitation() {
  const { partialSubmission } = useSubmissionsWorkspace();

  if (!partialSubmission) {
    return null;
  }

  return (
    <EmailEditorInnerPageContentWrapper
      locationState={{ mode: EmailEditorPageMode.SendSolicitation }}
      partialSubmission={partialSubmission}
    />
  );
}
